<template>
  <b-row>
    <p>{{ data.store.name }}</p>
    <label>Turn On / Off At ?</label>
    <b-col sm="12">
      <date-picker
        v-model="toggle_data.time"
        type="datetime"
        show-week-number
        :lang="lang"
      ></date-picker>
    </b-col>
    <b-col sm="12" class="mt-4">
      <b-button variant="success" @click="toggleStore">Save</b-button>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
import { StorePath } from "@/path";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  components: { DatePicker },
  name: "toggle_store",
  props: ["data"],
  data() {
    return {
      toggle_data: this.data,
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
      },
    };
  },
  methods: {
    async toggleStore() {
      try {
        let res = await axios.post(this.base_url + StorePath.STORE_TOGGLE_UP, {
          store_id: this.toggle_data.store.id,
          platforms: this.toggle_data.platform_data.text,
          action: this.toggle_data.action ? "enable" : "disable",
          time: this.toggle_data.time,
        });
        if (res.data.status) {
          this.$bvToast.toast(
            this.toggle_data.platform_data.text +
              "of store " +
              this.toggle_data.store.name +
              (this.toggle_data.action
                ? " Enabled Successfully"
                : " Disabled Successfully"),
            {
              title: `Store Toggled`,
              variant: "success",
              solid: true,
            }
          );
        } else {
          this.$bvToast.toast("Failed to toggle", {
            title: `Store Toggled`,
            variant: "danger",
            solid: true,
          });
        }
      } catch (e) {
        console.log(e);
      }
      this.$bvModal.hide("bv-toggle-store");
    },
  },
};
</script>

<style scoped></style>
